<template>
    <v-card>
        <v-card-title>
        </v-card-title>
        <v-card-text>
            <v-skeleton-loader type="heading"></v-skeleton-loader>
            <br>
            <v-skeleton-loader type="table-row"></v-skeleton-loader>
            <br>
            <v-row>
                <v-col><v-skeleton-loader type="card"></v-skeleton-loader></v-col>
                <v-col><v-skeleton-loader type="card"></v-skeleton-loader></v-col>
                <v-col><v-skeleton-loader type="card"></v-skeleton-loader></v-col>
            </v-row> 
        </v-card-text>
        <v-card-actions>
            <v-skeleton-loader type="button"></v-skeleton-loader>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: "CustomerDisplayDialogSkeleton"
}
</script>